import { Injectable } from '@angular/core';
import { Version, Versions } from '../../models';
import { IVersionsRepo } from '../interfaces/iversions.repo';

@Injectable()
export class TestVersionsRepo extends IVersionsRepo {

	private versions: Versions;

	constructor() {
		super();
		this.provisionVersions();
	}

	loadVersions(): Promise<Versions> {
		const servable = new Promise<Versions>(
			(resolve) => {
				resolve(this.versions);
			}
		);
		return servable;
	}

	provisionVersions(): void {
		const appVersion: Version = new Version('App Version', '0.0.1');
		const serverVersion: Version = new Version('Server Version', '0.0.2');
		this.versions = new Versions(appVersion, serverVersion);

	}
}
